import {
  Badge,
  Box,
  Flex,
  HStack,
  Spacer,
  useMediaQuery,
} from '@chakra-ui/react';
import { Avatar, Button, Text } from '@diamond/shared/ui';
import { format } from 'date-fns';
import idLocale from 'date-fns/locale/id';

export interface UserCardProps {
  id: string;
  name: string;
  imageUrl?: string;
  email: string;
  lastLogin: number;
  isAdmin?: boolean;
  isActive: boolean;
  hideButton: boolean;
  hideLabel: boolean;
  emailStatus: string;
  reqToAdmin: boolean;
  status: string;
  onClick: (id: string) => void;
  onClickChangeAdmin: (id: string) => void;
}

export function UserManagementCard({
  imageUrl,
  name,
  email,
  lastLogin,
  isAdmin,
  isActive,
  hideButton,
  hideLabel,
  id,
  status,
  onClick,
  emailStatus,
  reqToAdmin,
  onClickChangeAdmin,
}: UserCardProps) {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  return (
    <Flex
      w="full"
      direction="column"
      cursor="pointer"
      bg={isActive ? 'rgba(0, 0, 163, 0.1)' : 'white'}
      rounded="lg"
      border="2px"
      borderColor={isActive ? 'blue' : 'gray.33'}
      py={{ base: 2, md: 4 }}
      px={4}
    >
      <Box mb={2} display={isMobile ? 'block' : 'none'}>
        {isAdmin && (
          <Badge
            fontSize="xs"
            fontWeight="normal"
            rounded="lg"
            px="4"
            py="1"
            textAlign="center"
            variant="green"
          >
            Admin
          </Badge>
        )}
        {!isAdmin && reqToAdmin === true && !hideLabel && (
          <Badge
            fontSize="xs"
            fontWeight="normal"
            rounded="lg"
            px="4"
            py="1"
            textAlign="center"
            variant="orange"
          >
            Menunggu Persetujuan
          </Badge>
        )}
      </Box>
      <Flex onClick={() => onClick(id)}>
        <Flex justifyContent="center" alignItems="center">
          <Avatar
            size={{ base: 'md', md: 'md', lg: 'lg' }}
            name={name}
            src={imageUrl}
          />
        </Flex>

        <Box py="2" pl="4" pr="2" w="full">
          <Flex justifyContent="space-between">
            <Text fontWeight="bold">{name}</Text>
            <Box display={!isMobile ? 'block' : 'none'}>
              {isAdmin && (
                <Badge
                  fontSize="sm"
                  fontWeight="medium"
                  rounded="lg"
                  px="4"
                  py="1"
                  textAlign="center"
                  variant="green"
                >
                  Admin
                </Badge>
              )}
              {!isAdmin && reqToAdmin === true && !hideLabel && (
                <Badge
                  fontSize="sm"
                  fontWeight="medium"
                  rounded="lg"
                  px="4"
                  py="1"
                  textAlign="center"
                  variant="orange"
                >
                  Menunggu Persetujuan
                </Badge>
              )}
            </Box>
          </Flex>
          <Text fontSize={{ base: '12px', md: '14px' }} color="blue" as="u">
            {email && email.length > 27 && isMobile
              ? `${email.substring(0, 27)}...`
              : email}
          </Text>
          <HStack>
            {emailStatus !== 'pending' && status === 'active' && (
              <>
                <Text
                  color="gray.75"
                  fontSize={{ base: 'xs', md: 'sm' }}
                  fontWeight="semibold"
                  mt={{ base: 1, md: 0 }}
                >
                  Last login at:{' '}
                  {format(new Date(lastLogin), 'dd-MM-yyyy HH:mm', {
                    locale: idLocale,
                  })}
                </Text>
                <Spacer />
              </>
            )}
            <Flex
              display={
                status === 'active' &&
                !isAdmin &&
                !hideButton &&
                emailStatus === 'approved'
                  ? 'flex'
                  : 'none'
              }
            >
              <Button
                variant="solid"
                onClick={(e) => {
                  e.stopPropagation();
                  onClickChangeAdmin(id);
                }}
                display={{ base: 'none', md: 'inline-flex', lg: 'inline-flex' }}
                data-email={email}
              >
                Jadikan Admin
              </Button>
            </Flex>
          </HStack>
        </Box>
      </Flex>
      {!isAdmin &&
        emailStatus === 'approved' &&
        !hideButton &&
        status === 'active' && (
          <Box w="full" display={{ base: 'block', md: 'none', lg: 'none' }}>
            <Button
              variant="solid"
              onClick={(e) => {
                e.stopPropagation();
                onClickChangeAdmin(id);
              }}
              w="full"
              size="sm"
            >
              Jadikan Admin
            </Button>
          </Box>
        )}
    </Flex>
  );
}
